import { SxProps, Typography } from '@mui/material';
import React from 'react';
import { parseUsername } from '../../../util/DataUtils';

/**
 * Decorative component that is used for ensuring a consistent display of username data within a sidepanel.
 */
export default ({ username, sx }: IUsernameProps) => (
    <Typography
        sx={[
            {
                fontSize: '12px',
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ]}
    >
        {parseUsername(username)}
    </Typography>
);

/**
 * Interface that describes the props for a Username component.
 */
export interface IUsernameProps {
    /** Username to be displayed. */
    username: string;

    /** (Optional) Extra styles to be applied to the component. */
    sx?: SxProps;
}
